import { Component, Ref, Vue } from 'vue-property-decorator'
import { ICellEditorComp } from '@ag-grid-enterprise/all-modules'
import {
    CheckIconCellEditorParams,
    CheckIconCellEditorState,
    CheckIconModel,
    initialCheckIconCellEditorState
} from '@/cellEditors/check-icon/check-icon-cell-editor.model'

@Component
export default class CheckIconCellEditor<T> extends Vue implements ICellEditorComp {
    protected params!: CheckIconCellEditorParams<T> // initialized by ag-grid
    @Ref() readonly select!: any

    state: CheckIconCellEditorState
    constructor() {
        super()
        this.state = initialCheckIconCellEditorState()
    }

    get options(): CheckIconModel[] {
        return [
            { value: false, label: '', icon: 'fas fa-times tertiary-color' },
            { value: true, label: '', icon: 'fas fa-check success' }
        ]
    }

    get allowEmpty(): boolean {
        return this.params.allowEmpty ?? false
    }

    /// VUE HOOKS ///

    created(): void {
        this.state.value =
            this.options.find(option => option.value === this.params.value)
    }

    mounted(): void {
        this.focus()
    }

    beforeDestroy(): void {
        this.blur()
    }

    /// AG-GRID CELL EDITOR ///

    getGui(): HTMLElement {
        return this.select
    }

    getValue(): CheckIconCellEditorParams<T>['value'] {
        return this.state.value?.value
    }

    isCancelAfterEnd(): boolean {
        return this.params.allowEmpty === false &&
            this.state.value === null
    }

    isPopup(): boolean {
        return this.params.isPopup ?? false
    }

    /// METHODS ///

    focus(): void {
        this.select.activateDropdown()
    }
    blur(): void {
        this.select.deactivateDropdown()
    }
}
